var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help"},[_c('h2',[_vm._v("Self Destruct Kit Builder Help")]),_vm._v(" "),_c('section',[_c('h3',[_c('i',{staticClass:"fas fa-wrench"}),_vm._v(" Customize the Experience")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f83f4352","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/kits/1/help_builder.vue
// module id = 430
// module chunks = 0